<script>
  import { adminAuth } from "../../stores/adminAuth.js"
  import { push } from "svelte-spa-router"

  export let currentPage = "dashboard"

  const navigationItems = [
    { key: "target-sets", label: "ターゲット語セット" },
    { key: "vocabulary", label: "ポジティブ/ネガティブ語管理" },
    { key: "questionnaire", label: "アンケート設定" },
    { key: "url-generator", label: "URL生成" },
  ]

  function setCurrentPage(page) {
    currentPage = page
  }

  async function handleLogout() {
    if (!confirm("ログアウトしますか？")) {
      return
    }

    try {
      const result = await adminAuth.logout()
      if (result.success) {
        push("/admin")
      }
    } catch (error) {
      console.error("Logout failed:", error)
      alert("ログアウトに失敗しました")
    }
  }
</script>

<div class="admin-layout">
  <nav class="sidebar">
    <div class="sidebar-header">
      <h1>管理者ページ</h1>
    </div>
    <ul class="nav-menu">
      {#each navigationItems as item}
        <li>
          <button
            class="nav-item"
            class:active={currentPage === item.key}
            on:click={() => setCurrentPage(item.key)}
          >
            <span class="nav-label">{item.label}</span>
          </button>
        </li>
      {/each}
    </ul>
    <div class="sidebar-footer">
      <button class="logout-button" on:click={handleLogout}>
        <span class="logout-label">ログアウト</span>
      </button>
    </div>
  </nav>

  <main class="main-content">
    <div class="content-header">
      <h2>
        {navigationItems.find((item) => item.key === currentPage).label}
      </h2>
    </div>
    <div class="content-body">
      <slot />
    </div>
  </main>
</div>

<style lang="scss">
  :global(body) {
    padding: 0;
  }

  .admin-layout {
    display: grid;
    grid-template-columns: 280px 1fr;
    min-height: 100vh;
    background: #f8fafc;
  }

  .sidebar {
    background: #1e293b;
    color: white;
    padding: 0;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: sticky;
    top: 0;
    overflow-y: auto;
  }

  .sidebar-header {
    padding: 2rem 1.5rem;
    border-bottom: 1px solid #334155;

    h1 {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      color: #f1f5f9;
    }
  }

  .nav-menu {
    list-style: none;
    padding: 1rem 0;
    margin: 0;
    flex: 1;

    li {
      margin-bottom: 0.25rem;
    }
  }

  .sidebar-footer {
    padding: 1.5rem;
    border-top: 1px solid #334155;
  }

  .logout-button {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.75rem 1rem;
    background: none;
    border: 1px solid #475569;
    color: #cbd5e1;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.95rem;

    &:hover {
      background: #dc2626;
      color: white;
      border-color: #dc2626;
    }
  }

  .logout-icon {
    margin-right: 0.5rem;
    font-size: 1.125rem;
  }

  .logout-label {
    font-weight: 500;
  }

  .nav-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.75rem 1.5rem;
    background: none;
    border: none;
    color: #cbd5e1;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 0.95rem;

    &:hover {
      background: #334155;
      color: #f1f5f9;
    }

    &.active {
      background: #3b82f6;
      color: white;

      .nav-icon {
        transform: scale(1.1);
      }
    }
  }

  .nav-icon {
    margin-right: 0.75rem;
    font-size: 1.125rem;
    transition: transform 0.2s ease;
  }

  .nav-label {
    font-weight: 500;
  }

  .main-content {
    display: flex;
    flex-direction: column;
  }

  .content-header {
    background: white;
    padding: 1.5rem 2rem;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    h2 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 600;
      color: #1e293b;
    }
  }

  .content-body {
    flex: 1;
    padding: 2rem;
    overflow-y: auto;
  }

  // レスポンシブ対応（タブレット以下では簡略化）
  @media (max-width: 768px) {
    .admin-layout {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr;
    }

    .sidebar {
      position: static;
      height: auto;
    }

    .nav-menu {
      display: flex;
      overflow-x: auto;
      padding: 0.5rem;

      li {
        margin-bottom: 0;
        margin-right: 0.25rem;
      }
    }

    .nav-item {
      white-space: nowrap;
      padding: 0.5rem 1rem;
    }

    .nav-label {
      display: none;
    }
  }
</style>
